module.exports = __webpack_public_path__ + "static/media/restaurant-food4.6f14321d.jpeg";